export default function NoData () {
  return(
    <span className="text-data-not-found">Data Not Found!</span>
  )
}